import DOMPurify from 'dompurify';
import React from 'react';
import './SafeHTMLDisplay.css';

const HTML_TAG_PATTERN = /<\/?[a-z][\s\S]*>/i;

const SafeHTMLDisplay: React.FC<{ htmlContent: string }> = ({ htmlContent }) => {
  const regex = /\{\{(.*?)\}\}/g;
  const boldRegex = /\*\*(.*?)\*\*/g;

  if (!htmlContent) return <></>;

  if (HTML_TAG_PATTERN.test(htmlContent)) {
    const sanitizedHTML = DOMPurify.sanitize(htmlContent);
    return (
      <div
        className="safe-html-display"
        dangerouslySetInnerHTML={{ __html: sanitizedHTML }}
      />
    );
  }

  const paragraphs = htmlContent.split('\n').map((line, index) => {
    let formattedLine = line.replace(regex, (match, value) => {
      return `<strong>${value}</strong>`;
    });

    formattedLine = formattedLine.replace(boldRegex, (match, value) => {
      return `<b>${value}</b>`;
    });

    const sanitizedHTML = DOMPurify.sanitize(formattedLine);
    return (
      <div
        key={index}
        dangerouslySetInnerHTML={{ __html: sanitizedHTML.trim() }}
        style={{ marginBottom: '10px', lineHeight: '1.6', fontSize: '18px' }}
      />
    );
  });

  return <div>{paragraphs}</div>;
};

export default SafeHTMLDisplay;
